import React from 'react';
import { Select } from 'antd';
import styles from '../../pages/projects/Projects.module.scss';

interface VersionManagerProps {
  fileDetail: any;
  versions: any[];
  versionsLoading: boolean;
  selectedVersion: number;
  compareMode: boolean;
  onVersionChange: (version: string) => void;
}

const VersionManager: React.FC<VersionManagerProps> = ({
  fileDetail,
  versions,
  versionsLoading,
  selectedVersion,
  compareMode,
  onVersionChange
}) => {
  // Get version options for guest users
  const getAccessibleVersions = () => {
    if (!fileDetail?.versions) return [];
    return fileDetail.versions;
  };

  const accessibleVersions = getAccessibleVersions();

  // Get version options
  const getVersionOptions = () => {
    if (!accessibleVersions) return [];
    
    return accessibleVersions.map((version: any) => ({
      label: version.name,
      value: version.name, // ID yerine name kullan
      disabled: false
    }));
  };

  const versionOptions = getVersionOptions();

  // Handle version selection with URL hash update
  const handleVersionSelect = (value: string) => {
    // Versiyon name'ini callback'e geç
    onVersionChange(value);
    
    // Update URL hash
    const selectedVersionData = versions.find((v: any) => v.name === value);
    if (selectedVersionData?.name) {
      window.location.hash = selectedVersionData.name;
    } else if (selectedVersionData?.path) {
      const pathParts = selectedVersionData.path.split('/');
      const versionName = pathParts[pathParts.length - 1];
      if (versionName) {
        window.location.hash = versionName;
      }
    }
  };

  // Don't render in compare mode (handled by VideoPlayerSection)
  if (compareMode) {
    return null;
  }

  return (
    <div className={styles.versionManagerContainer}>
      <div className={styles.versionSelectContent}>
        <Select
          placeholder="Select version"
          value={(() => {
            if (selectedVersion && versions.length > 0) {
              const selectedVersionData = versions.find((v: any) => v.id === selectedVersion);
              return selectedVersionData?.name || selectedVersion;
            }
            return undefined;
          })()}
          onChange={handleVersionSelect}
          loading={versionsLoading}
          className={styles.versionSelect}
          options={versionOptions}
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    </div>
  );
};

export default VersionManager; 